import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { TestsState } from '@playground/models/types';

interface Props {
  testsStatus: TestsState;
  runTests: () => void;
}

const RunTestsBtn: FunctionComponent<Props> = ({ testsStatus, runTests }) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex mt-4 md:mt-0">
      <button
        className={classNames(
          'inline-block rounded-sm text-platzi-dark bg-platzi-green  duration-300 font-bold capitalize text-xs px-4 py-2  w-full  opacity-90 hover:opacity-100 cursor-pointer',
          {
            'cursor-not-allowed text-gray-800':
              testsStatus === 'running' || testsStatus === 'initialising',
          }
        )}
        type="button"
        disabled={testsStatus === 'running' || testsStatus === 'initialising'}
        onClick={() => runTests()}
      >
        {testsStatus === 'running' ? `${t('codeRunner.analyzing')}` : `${t('codeRunner.runTests')}`}
      </button>
    </div>
  );
};

export default RunTestsBtn;
